import React, { useEffect, useState } from "react";
import {
  NewTab,
  PageHeader,
  PageTab,
  PageTabAdv,
  PageTitle,
} from "../../../components";
import AllEmployees from "./Employees/AllEmployees";
import AllConsultants from "./Employees/AllConsultants";
import AllContractors from "./Employees/AllContractors";
import ExitEmployees from "./Employees/ExitEmployees";
import BenchConsultants from "./Employees/BenchConsultants";
import Billings from "./Employees/Billings";

const Employee = () => {
  const openAddUserModal = () => {
    alert("open Add User Modal");
  };
  const EmployeeMenus = [
    {
      title: "Billings",
      page: <Billings />,
      type: "main",
    },
    // {
    //   title: "Overview",
    //   page: <AllEmployees tab="Overview" />,
    //   type: "main",
    // },
    {
      title: "Employees",
      page: <AllEmployees tab="Employees" />,
      type: "main",
    },
    {
      title: "Contractors",
      page: <AllContractors />,
      type: "main",
    },
    {
      title: "Bench Employees",
      page: <BenchConsultants />,
      type: "main",
    },
    {
      title: "Permanent Placements",
      page: <AllConsultants />,
      type: "main",
    },
    {
      title: "Exit Employees",
      page: <ExitEmployees />,
      type: "main",
    },
    {
      title: "Add Employee",
      link: "/employee/add-employee",
      type: "sub",
      icon: "add",
    },
  ];

  return (
    <>
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Employee Management"} tag="h5" />
          </div>
        }
      />
      <NewTab
        tabs={EmployeeMenus}
        color="black"
        variant="outlined"
        mode="url"
        tabId="employee-management"
      />
    </>
  );
};

export default Employee;
